import React from 'react';
import * as Sentry from '@sentry/browser';
import { ErrorBoundaryFallback } from './errorBoundaryFallback';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  tryHandleChunkLoadError = (error) => {
    if (error.name === 'ChunkLoadError' && error.type === 'missing') {
      const previousMessage = sessionStorage.getItem('leazard-chunk-load-error');
      sessionStorage.setItem('leazard-chunk-load-error', error.message);

      // Only attempt an automatic page reload for a missing chunk once
      if (previousMessage !== error.message) {
        window.location.reload();
        return true;
      }
    }
    return false;
  };

  componentDidCatch(error, errorInfo) {
    if (!this.tryHandleChunkLoadError(error)) {
      Sentry.withScope((scope) => {
        scope.setExtras({ extras: errorInfo });
        const eventId = Sentry.captureException(error);
        this.setState({ eventId });
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorBoundaryFallback language={this.props.language} />;
    }

    return this.props.children;
  }
}
